var _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtectorHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 11,
    width: 12,
    height: 12,
    rx: 2.5,
    fill: "url(#pattern0_1638_17369)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "url(#pattern1_1638_17369)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "url(#pattern2_1638_17369)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(-1 0 0 1 20 0)",
    fill: "url(#pattern3_1638_17369)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1638_17369",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1638_17369",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_1638_17369",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1638_17369",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_1638_17369",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1638_17369",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_1638_17369",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_1638_17369",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1638_17369",
    width: 96,
    height: 96,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACT0lEQVR4nO2dS25UMRREPYHFQLYTFyvIaghfsYksIHZEsgNmkIWQZEaDIzfKJELpAXo+N3Yd6U7bVbf8k1p6TskYY4zZCtX2ZNFE1ze9QQXXN71BBdc3vUEF1ze9QQXXN71BBdc3vUEF1ze9QQXXd5B8cZRy/ZBy/ZFyuTto6LlXLnd/vXbPF0dc44/PXibVLynX33hThNUu5fJ534vhzc/lKkADWojK9XJsCH3m06YVrcqnMc3v+15ferjhGq126U15PSCA+jGA2Raycnm3fQCq17hRRa3yfUAA5ZY3WqPWzYAAcJMtdDmA6gDwWSivAL4R8hbEN0NA+QyoDgCfhfIK4Bshb0F8MwSUz4DqAPBZKK8AvhFadQuaHdH+cQEwuH9cAAzuHxcAg/vHBcDg/nEBMLh/XAAM7h8XAIP7xwXA4P5xATC4f1wADO4fFwCD+6cFaPHxcQFafHxcgBYfHxegxcfHBWjx8XEBWnx8XIAWHx8XoMXH31yADvz+/1Z0/7gAOQAH8BQqf7wCRG5BDqA5gKXPgOItKDkAr4A07TU0/Pizb0Hhx3cAzQF4BTRvQfIW5DNAPoSbD2Hfgtpa11Ca5a+hNA4AxgHAOAAYBwDjAGAcAEyAAG42/9tQz7Ry/TkiAH+6WOyni9/jM01Rq7zdPoD+iXZ/vr79I4BdOj5/lYbQn+3AZ1uNVf1NmbFPmNRL3LTC1Nd08u3FuAAeQujPdiy9HZVf+5k/vPmPz4T+ckS/ASzxtkC53XvN9XTcnm+MMcYYY4wxxhhj0gTcAwrWFFSoFKkEAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_1638_17369",
    width: 100,
    height: 100,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC20lEQVR4nO3bP2gTcRTA8acooiAOurqIkyCoUwXBRdRBpcu9X+wq1EEnF8WlBfHf7OYkHRwylULv90KGji51q4Pi5iAIIl0KClq5WFIVmktyl9zr5fuB39i7y337krsjEQEAAACA3ShpHhRtXZdgz0VtQUJ8KSE+FI3nqj60yTI3t1eC3ZVgXyTY5g7rjSTxfNWHWn/Xlg6J2mKPENtL4w/ReLvqQ66xzT0S7HVfMbor/hJNG1UfeT0FmxksRjfKN5luH83dfpJekGD3d/3KXsdYqL0fLkhnPcrdfojzBbbvaMX50cdIWmcKHaTGDwQpU0hvFf7PubF4uPc+IhPSfxB7UDhIYicJUpZGvFM4yM2lYz33EZiQ/oXW5YIfdF87l80EKcnV9ICorQ//oW4LufsITMhggj0ZMsZPaaRn87ffmpUQV/0v26j+sjeTtI+I2schLnlfSJ2orfkIkknSUxLs8wBBlmV2db/UiXoKkgl2XNRWckJ8F41P5eLKPqkb9Rake2DxioT4auttbKNzJRXsrag9lpn2Cakr9RpkUilBfCGIMwRxppIgGp9VfwMWiy+Nl+oRJFiz2LMrLysmpZ8bghhBmJAemBBjQpiQHpgQY0KYkEmckOwrqdn9jo5wJcunSz83tQ0yinuEcSCIMwRxhiDOEMQZgjhDEGcI4gxBnCGIMwRxhiDOEKTMk5X7wHOt+D54uLiNIM6e9ioTQpDAW9bOmBAmRJiQHpgQJkQmZkI0ndo6jv5XkZ9u/7kPWS9hH+/+/Zt4rx5BQkxGfwxjWU2ChMojEESqP/EEkepPNkGk+hNMEKn+pBJEuMoa4LJX7VMf9wXjvw8JHtd47kPyr62LBsFfCOIMQZwhiDMEcYYgzhDEGYI4QxBnCOIMQZwhiDMEcYYgzhDEGYI4QxBnCOIMQZwhiDMEcYYgzhDEGYI4k325q+iXv3J/+JJOjeW1AAAAAADkf78ByAKMJoJZ0OsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectorHover);
export default __webpack_public_path__ + "static/media/protector-hover.56717874b07eb64b38523998e90a6965.svg";
export { ForwardRef as ReactComponent };